export enum SlateGroupScope {
	BY_DAY = 'BY_DAY',
	BY_WEEK = 'BY_WEEK',
	BY_MONTH = 'BY_MONTH',
}
